import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'pt-details-application-vulnerability-cvs-severity',
  template: `
    <div class="cvs-container flex-row-reverse" *ngIf="currentCveSeverity?.length > 0">
      <ng-container *ngFor="let c of currentCveSeverity">
        <div class="cvs-item cursor-default"
             [ngClass]="c.cssClass"
             [style.width]="c.width + 'px'"
             container='body' [ngbTooltip]="TooltipTemplate">
          {{ c.value }}
        </div>
        <ng-template #TooltipTemplate>
          <div class="cursor-default">
            {{ c.tooltip | async }}
            <p class="text-center mb-0 cursor-default">{{ c.value }}</p>
          </div>
        </ng-template>
      </ng-container>
    </div>
  `,
  styles: [`
    .chart-bar {
      height: 100px !important;
      width: 100% !important;
      margin: 0 10px 10px 10px;
    }
    .cvs-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: nowrap;
      padding: 2px 10px;
      width: 390px;
    }

    .cvs-container .cvs-item {
      text-align: center;
      color: white;
      font-weight: bold;
    }

    .cvs-container .cve-critical {
      /*background: var(--ptVeryHigh);*/
      background: #F86C6B;
    }

    .cvs-container .cve-high {
      /*background: var(--ptHigh);*/
      background: #FD8C00;
    }

    .cvs-container .cve-medium {
      /*background: var(--ptMedium);*/
      background: #FFC107;
    }

    .cvs-container .cve-low {
      /*background: var(--ptLow);*/
      background: #4DBD74;
    }

    .cvs-container .cve-na {
      /*background: var(--ptNa);*/
      background: #777777;
    }

    .cvs-container .cve-none {
      /*background: var(--ptNone);*/
      background: #989898FF;
    }

  `]
})
export class DetailsApplicationAuditCveSeverityComponent implements OnChanges {
  @Input() cveSeverity!: Array<number>;
  cveSeverityEvalLabels: Array<string> = ["Critico", "Alto", "Medio", "Basso", "Nessuno"];

  // assertEquals(0, cveSeverity.get(0));//critical
  // assertEquals(1, cveSeverity.get(1));//high
  // assertEquals(0, cveSeverity.get(2));//medium
  // assertEquals(0, cveSeverity.get(3));//low

  public options: EChartsOption;
  public currentCveSeverity: CveSeverity[] = [];


  public static getCveSeverityType(v: number): CveSeverityType {
    switch (v) {
      case 0:
        return CveSeverityType.CRITICAL;
      case 1:
        return CveSeverityType.HIGH;
      case 2:
        return CveSeverityType.MEDIUM;
      case 3:
        return CveSeverityType.LOW;
      case 4:
        return CveSeverityType.NONE;
      default:
        return CveSeverityType.NONE;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.cveSeverity && this.cveSeverity.length > 0) {
      this.alignCve(this.cveSeverity);
    } else {
      this.noCve();
    }
  }

  private alignCve(cveSeverity: Array<number>) {
    const maxWidth = 400; // espresso in px
    const minWidthForCve = 15; // espresso in px;
    const totalNumOfValue = cveSeverity.length;
    const variableSpace = maxWidth - (minWidthForCve * cveSeverity.length);

    let totalValue = 0;
    cveSeverity.forEach((c) => totalValue += c);
    const currentCveSeverity: CveSeverity[] = [];
    if (totalValue > 0) {
      cveSeverity.forEach((c, index) => {
        const width = minWidthForCve + ( (variableSpace / totalValue) * c);
        const type = DetailsApplicationAuditCveSeverityComponent.getCveSeverityType(index);
        const cve: CveSeverity = {
          value: c,
          width,
          type,
          cssClass: "cve-" + type.toLocaleLowerCase(),
          tooltip: of(this.cveSeverityEvalLabels && this.cveSeverityEvalLabels.length > index ? this.cveSeverityEvalLabels[index] : 'na')
        };
        currentCveSeverity.push(cve);
      });
      this.currentCveSeverity = currentCveSeverity;
    } else {
      this.noCve()
    }
  }

  private noCve() {
    // const cve: CveSeverity = {
    //   value: 0,
    //   width: 100,
    //   cssClass: "cve-na",
    //   type: CveSeverityType.NA,
    //   tooltip: of('na')
    // }
    // this.currentCveSeverity = [cve];
    this.currentCveSeverity = [];
  }
}

interface CveSeverity {
  value: number;
  width: number;
  type: CveSeverityType,
  cssClass: string;
  tooltip: Observable<string>
}


export enum CveSeverityType {
  NONE = 'NONE',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}
